import { render, staticRenderFns } from "./GroupDashboardMonthlyReturn.vue?vue&type=template&id=8454f97e&"
import script from "./GroupDashboardMonthlyReturn.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardMonthlyReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports